import React from "react";
import SummariesBody from "./SummariesBody";
import './sass/summaries.css';

export const Summaries = ({ jsonDataSummaries, dictionary }) => {

  const jsonData = jsonDataSummaries?.summaries || {};

  return (
    <>
      {jsonData &&
          <React.Fragment>
            {jsonData.data?.map((data) => (
                data.header ?
                   <div className="resume" key={data.header.module} id={data.header.module}>
                        <SummariesBody data={data} dictionary={dictionary} />
                      </div> 
                : <></>
            ))}
          </React.Fragment>
      }
    </>
  );
}
